import axios from "axios";

const apiCall = axios.create({
    baseURL: import.meta.env.REACT_APP_API_DOMAIN,
    timeout: 90000,
});

export default apiCall;
